import { FileText } from 'lucide-react';

export function PaymentsTaxInfo({ teacherName }: { teacherName: string }) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
      <FileText className="h-4 w-4 flex-shrink-0" />
      <p>
        Tax information: {teacherName}. Air Education Inc 548 Market St PMB 335427, San Francisco, California 94104-5401
        US.
      </p>
    </div>
  );
}
